import TrackerManager from 'src/utils/TrackerManager';
import { playerSettings } from '../common/constants';
import { AAF_CONTENT_IS_TV } from '../../../AAFPlayer/constants';
import logger from 'src/utils/logger/logger';

const sendForwardRewindSeek = (timeshiftData, _this) => {
  logger.debug('[NPC] SEND STATS SEEK LiveTS');
  const isBackward = timeshiftData.backward;
  const seekTime = isBackward
      ? playerSettings.getBackwardTimeByStreamtypeTS(AAF_CONTENT_IS_TV)
      : playerSettings.getForwardTimeByStreamtypeTS(AAF_CONTENT_IS_TV);
  const currentTime = _this.getCurrentTime();
  const validateSeekTime = seekTime === 15 || seekTime === 10;

  if (isBackward && validateSeekTime) {
      TrackerManager.rewind(currentTime);
  } else if (!isBackward && validateSeekTime) {
      TrackerManager.foward(currentTime);
  }
};

export const utilsSeeks = {
  sendForwardRewindSeek
}



// WEBPACK FOOTER //
// ./src/playerDomain/components/seeks/utils.js